import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Player from "./Player";
// import Slide1 from "./Slide1";
// import Slide2 from "./Slide2";
// import Slide3 from "./Slide3";
// import Slide4 from "./Slide4";
// import Slide5 from "./Slide5";
// import Slide6 from "./Slide6";
import Slide7 from "./Slide7";

// import image from "../../Assets/Diana/5.jpg";
// import image1 from "../../Assets/Diana/heorshe.png";

import "swiper/css";
import GenericSlide from "./GenericSlide";
// import GenericSlide2 from "./GenericSlide2";

export default function DetailsSwiper({ width, height, event }) {
  const [slides, setSlides] = useState([]);
  const searchParams = new URLSearchParams(document.location.search);

  useEffect(() => {
    const currentSlides = event.slides;
    let remainingSlides = [];

    if (searchParams.get("nc") === "t") {
      currentSlides.forEach((slide) => {
        const slideJSON = JSON.parse(slide.attribute_2);
        if (!slideJSON.isRSVP) {
          remainingSlides.push(slide);
        }
      });
    } else {
      remainingSlides = [...currentSlides];
    }

    setSlides([...remainingSlides]);
  }, [event]);
  return (
    <Swiper
      spaceBetween={0}
      slidesPerView={1}
      onSlideChange={(e) => console.log(e)}
      onSwiper={(swiper) => console.log(swiper)}
      className="sliderContainer overlayed"
      style={{ width: "100%", height: height, position: "relative" }}
    >
      <div
        style={{
          position: "absolute",
          bottom: 35,
          zIndex: 99999,
          width: "60px",
        }}
      >
        <Player audio={event.audio} />
      </div>
      {slides.map((slide, index) => (
        <SwiperSlide key={index} className="slide">
          <GenericSlide slide={slide} event={event} />
        </SwiperSlide>
      ))}

      <SwiperSlide className="slide">
        <Slide7
          image={`${process.env.REACT_APP_BACKEND_URL}${event.last_slide_image}`}
        />
      </SwiperSlide>
    </Swiper>
  );
}
